function write(level, event, context) {
    const entry = context ? [event, context] : [event];
    if (level === "debug")
        console.debug(...entry);
    else if (level === "info")
        console.info(...entry);
    else if (level === "warn")
        console.warn(...entry);
    else
        console.error(...entry);
}
export const log = {
    debug: (event, context) => write("debug", event, context),
    info: (event, context) => write("info", event, context),
    warn: (event, context) => write("warn", event, context),
    error: (event, context) => write("error", event, context),
};
